(function() {
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    function updatePriceContainer(priceContainer) {
        priceContainer.classList.add('price--on-sale');

        const currentPriceEl = priceContainer.querySelector('.price__current');
        const wasPriceEl = priceContainer.querySelector('.price__was');
        const defaultPriceEl = priceContainer.querySelector('.price__default');

        if (!currentPriceEl || !wasPriceEl || !defaultPriceEl) return;

        // Originalpreis in price__was einfügen, falls noch leer
        if (!wasPriceEl.textContent) {
            wasPriceEl.textContent = currentPriceEl.textContent.trim();
        }

        // Neuer Preis (80%)
        let priceText = currentPriceEl.textContent.trim();
        let numericPrice = parseFloat(priceText.replace('€','').replace(/\./g,'').replace(',','.'));
        let discountedPrice = ((numericPrice * 0.8) + 0.005).toFixed(2).replace('.', ',');
        currentPriceEl.textContent = discountedPrice + ' €';

        // Neues promoDiv einfügen
        const promoDiv = document.createElement('div');
        promoDiv.className = 'text-sm rte gemaPromo';
        promoDiv.innerHTML = '<b>Exklusiver GEMA x TITUS Angebotspreis</b>';
        defaultPriceEl.after(promoDiv);

        addGemaLabel(priceContainer);
    }

    function addGemaLabel(priceContainer) {
        // --- GEMA Label hinzufügen ---
        const card = priceContainer.closest('.card');
        if (!card) return;

        const mediaContainer = card.querySelector('.card__media');
        if (!mediaContainer) return;

        // Prüfen, ob Label bereits existiert
        if (mediaContainer.querySelector('.product-label--gema')) {
            return;
        }

        // Label-Container ggf. anlegen
        let labelContainer = mediaContainer.querySelector('.product-label-container');
        if (!labelContainer) {
            labelContainer = document.createElement('div');
            labelContainer.className = 'product-label-container absolute bottom-0 start';
            mediaContainer.appendChild(labelContainer);
        }

        // Wrapper + Label erzeugen
        const wrapper = document.createElement('div');
        wrapper.className = 'product-label-wrapper flex';

        const label = document.createElement('span');
        label.className = 'product-label product-label--gema';
        label.textContent = 'School\'s Out Now';

        wrapper.appendChild(label);
        labelContainer.appendChild(wrapper);
    }

    function replaceSaleLink() {
        // Sale-Element
        const labels = ['Sale', '% Sale', 'Soldes', '% Soldes', 'Venta', '% Venta', 'Salg', '% Salg', 'Vendita', '% Vendita'];
        const saleLink = Array.from(
            document.querySelectorAll('a.main-nav__item--primary.main-nav__item-content')
        ).find(el => labels.includes(el.textContent.trim()));
        if (saleLink) {
            saleLink.textContent = 'School\'s Out Now';
            saleLink.href = '/pages/schools-out-now';
            // Untermenü entfernen
            const liParent = saleLink.closest('li');
            if (liParent) {
                const childContainer = liParent.querySelector('.main-nav__child');
                if (childContainer) childContainer.remove();

                const details = liParent.querySelector('details');
                const summary = liParent.querySelector('summary');

                if (summary) summary.remove();
                if (details) {
                    if (!liParent.contains(saleLink)) {
                        liParent.appendChild(saleLink);
                    }
                    details.remove();
                }
            }
            saleLink.style.pointerEvents = 'auto';
        }
    }

    function applyDiscount(lazy = false) {
        const isProduct = window.location.pathname.includes('/products/');
        const isCollection = window.location.pathname.includes('/collections/');
        const isPage = window.location.pathname.includes('/pages/');

        replaceSaleLink();
        
        if (isProduct && !lazy) {

            const priceContainer = document.querySelector('div.product-info__price > div.price');
            if (!priceContainer) return;

            // Immer vorhandenes promoDiv entfernen, egal ob Bedingungen zutreffen oder nicht
            const existingPromo = priceContainer.querySelector('.gemaPromo');
            if (existingPromo) existingPromo.remove();

            // Klasse hinzufügen, falls nicht vorhanden
            if (!priceContainer.classList.contains('price--on-sale')) {
                updatePriceContainer(priceContainer);
            }
        }

        if (isCollection || isProduct || isPage) {
            const priceContainers = document.querySelectorAll('div.card__info-inner > div.price');
            for (const priceContainer of priceContainers) {
                if (!priceContainer.classList.contains('price--on-sale')) {
                    updatePriceContainer(priceContainer);
                }
            }
        }        
    }

    // Prüfen ob ein passender Aktionscode hinterlegt ist
    const discountCode = getCookie('discount_code');
    const isEligible = discountCode && discountCode.toUpperCase().startsWith('GXT26');
    if (isEligible) {

        // Initial einmal ausführen
        applyDiscount();

        const isProduct = window.location.pathname.includes('/products/');
        if (isProduct) {
            // Event-Listener für Option-Labels
            const optionLabels = document.querySelectorAll('.option-selector__btns > label');
            optionLabels.forEach(label => {
                label.addEventListener('click', function() {
                    setTimeout(applyDiscount, 50);
                });
            });

            // add listener to trigger applyDiscount() again after lazyload elements have been loaded
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.addedNodes.length > 0) {
                        applyDiscount(true);
                    }
                });
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }

        // Promos ausblenden
        const gStyle = document.createElement('style');
        gStyle.textContent = '.cc-promo-strip { display: none !important; }';
        document.head.appendChild(gStyle);

    }

})();